// Dados da landing — De Paula & Silva

/** Mensagem pré-definida do WhatsApp (hero, botão flutuante). */
export const WHATSAPP_WELCOME_MESSAGE = `Olá! Seja bem-vindo(a) ao atendimento jurídico.
Para iniciarmos seu atendimento, nos informe:
* Nome completo
* Área do problema (ex: banco, consumidor, trabalhista, previdenciário, penal, etc.)
* Um breve resumo do caso
Assim conseguimos direcionar sua demanda da melhor forma.`;

export function getWhatsAppUrl(text = WHATSAPP_WELCOME_MESSAGE) {
  const digits = lawyerData.phone.replace(/\D/g, "");
  return `https://wa.me/55${digits}?text=${encodeURIComponent(text)}`;
}

export const CONTACT_AREA_OPTIONS = [
  { value: "bancario", label: "Bancário — Problemas com bancos ou cobranças" },
  { value: "consumidor", label: "Consumidor — Produtos, serviços ou reembolsos" },
  { value: "civel_contratos", label: "Cível / Contratos — Contratos e conflitos entre particulares" },
  { value: "trabalhista", label: "Trabalhista — Rescisão e verbas trabalhistas" },
  { value: "previdenciario", label: "Previdenciário (INSS) — Benefícios e aposentadoria" },
  { value: "penal", label: "Penal — Orientação e acompanhamento" },
  { value: "outro", label: "Outro" }
];

export const lawyerData = {
  firmName: "DE PAULA & SILVA",
  firmTagline: "ADVOCACIA, ASSESSORIA E CONSULTORIA JURÍDICA",
  name: "Dra. Jessica de Paula Silva",
  tagline: "Seus direitos merecem ser respeitados.",
  subtagline:
    "Atuação jurídica segura, estratégica e comprometida com o seu caso.",
  heroDescription:
    "Atuação nas áreas cível, consumerista, bancária, trabalhista e previdenciária, com orientação clara e acompanhamento em todas as etapas do processo.",
  onlineNote: "Atendimento online e personalizado",
  email: "jessicadpaula@adv.oabsp.org.br",
  phone: "(11) 93398-8154",
  instagram: "https://www.instagram.com/dra.de_paula_jessica/",
  instagramHandle: "@dra.de_paula_jessica",
  linkedin: "https://www.linkedin.com/in/j%C3%A9ssica-de-paula-silva-a117901b3",
  hours: "Segunda a Sexta: 9h às 18h",
  logo: "/assets/logo-de-paula-silva.png",
  about: {
    title: "Conheça a Dra.",
    sectionHeadline: "Conheça a profissional que vai cuidar do seu caso",
    photo:
      "/assets/Dra. Jéssica de Paula_@soma_photografia_ (7 of 21)-Photoroom.png",
    paragraphs: [
      "Advogada com atuação em advocacia preventiva e contenciosa, dedicada a oferecer soluções jurídicas seguras, estratégicas e personalizadas para cada cliente.",
      "A trajetória no Direito teve início a partir de uma experiência pessoal com a violação de direitos trabalhistas, o que despertou o propósito de atuar na defesa de pessoas que, muitas vezes, não conhecem ou não conseguem exercer plenamente seus direitos.",
      "Diante dessa realidade, o escritório trilha o caminho da advocacia com um objetivo claro: garantir que cada cliente tenha seus direitos respeitados, com orientação jurídica séria, responsável e acessível.",
      "Hoje, a atuação é pautada em dedicação, responsabilidade e proximidade, tratando cada caso de forma individualizada, com análise estratégica e acompanhamento contínuo em todas as etapas do processo.",
      "A confiança se constrói com clareza e transparência. Por isso, mantemos uma comunicação objetiva, garantindo que o cliente se sinta seguro e bem informado durante toda a condução do seu caso."
    ],
    values: [
      "Ética profissional",
      "Sigilo absoluto",
      "Comprometimento com o cliente",
      "Transparência na comunicação"
    ]
  },
  form: {
    title: "Solicite uma análise inicial do seu caso",
    description:
      "Preencha as informações ao lado para que nossa equipe compreenda sua situação e possa orientar você da melhor forma.",
    responseTime: "Retorno em até 24 horas úteis",
    privacyNote: "Seus dados serão tratados com confidencialidade."
  },
  contact: {
    headline: "Estamos aqui para ajudar você.",
    description: "Nossa equipe está à disposição para orientar você da melhor forma.",
    whatsappLabel: "Fale no WhatsApp",
    whatsappNote: "Atendimento rápido e direto",
    emailLabel: "E-mail",
    instagramNote: "Acompanhe nosso trabalho no Instagram"
  }
};

export const practiceAreas = [
  {
    id: 1,
    title: "Problemas com bancos e cobranças indevidas",
    description:
      "Negativação indevida, bloqueio de contas, cobranças abusivas e conflitos com instituições financeiras.",
    icon: "DollarSign"
  },
  {
    id: 2,
    title: "Direito do consumidor",
    description:
      "Problemas com produtos ou serviços, cancelamentos, reembolsos e descumprimento de oferta.",
    icon: "ShoppingBag"
  },
  {
    id: 3,
    title: "Questões cíveis e contratuais",
    description: "Elaboração e revisão de contratos e resolução de conflitos entre particulares.",
    icon: "FileText"
  },
  {
    id: 4,
    title: "Direitos trabalhistas",
    description: "Rescisões, verbas trabalhistas e demais questões da relação de trabalho.",
    icon: "Briefcase"
  },
  {
    id: 5,
    title: "Benefícios previdenciários (INSS)",
    description:
      "Requerimentos, revisões, recursos e acompanhamento administrativo.",
    icon: "Shield"
  },
  {
    id: 6,
    title: "Consultoria e orientação em direito penal",
    description:
      "Atuação inicial em orientações jurídicas, acompanhamento de inquéritos e suporte ao cliente em questões penais.",
    icon: "Search"
  }
];

export const differentials = [
  {
    id: 1,
    title: "Atendimento personalizado",
    description:
      "Cada cliente recebe atenção individualizada, com estratégias desenvolvidas especificamente para cada caso."
  },
  {
    id: 2,
    title: "Comunicação transparente",
    description:
      "O cliente permanece informado sobre cada etapa do processo, com linguagem clara e acessível."
  },
  {
    id: 3,
    title: "Ética profissional",
    description:
      "Atuação rigorosa conforme o Código de Ética e Estatuto da OAB, garantindo integridade em todas as ações."
  },
  {
    id: 4,
    title: "Estratégia jurídica",
    description: "Análise aprofundada de cada caso para encontrar a melhor solução jurídica possível."
  }
];

/** Avaliações dos clientes — substitua pelos comentários reais e pelos links do Google Maps. */
export const googleMapsReviewsUrl =
  "https://www.google.com/maps/search/?api=1&query=Dra+Jessica+de+Paula+Silva+Advocacia";

export const testimonials = [
  {
    id: 1,
    name: "M. A.",
    role: "Direito do consumidor",
    text: "Atendimento claro e cuidadoso do início ao fim. Me senti segura e bem orientada em cada etapa.",
    rating: 5,
    mapsUrl: ""
  },
  {
    id: 2,
    name: "R. S.",
    role: "Questões bancárias",
    text: "Profissionalismo e transparência. A Dra. explicou tudo com objetividade e acompanhou o caso de perto.",
    rating: 5,
    mapsUrl: ""
  },
  {
    id: 3,
    name: "C. L.",
    role: "Direito trabalhista",
    text: "Recomendo pelo comprometimento e pela comunicação acessível. Resolvemos a demanda com seriedade.",
    rating: 5,
    mapsUrl: ""
  }
];

export const images = {
  logo: "/assets/logo-de-paula-silva.png",
  heroBackground: "/assets/background-banner.jpg",
  heroPhoto: "/assets/Dra. Jéssica de Paula_@soma_photografia_ (4 of 21)-Photoroom.png",
  aboutPhoto:
    "/assets/Dra. Jéssica de Paula_@soma_photografia_ (8 of 21)-Photoroom.png",
  ctaPhoto:
    "/assets/Dra. Jéssica de Paula_@soma_photografia_ (13 of 21)-Photoroom.png",
  differentialsPhoto:
    "/assets/Dra. Jéssica de Paula_@soma_photografia_ (7 of 21)-Photoroom.png",
  lawyerPhoto:
    "/assets/Dra.%20J%C3%A9ssica%20de%20Paula_%40soma_photografia_%20(8%20of%2021)-Photoroom.png"
};
